import React, { useEffect, useState } from 'react';
import api from '../../utils/api';

const empty = { title: '', description: '', discount: '', code: '', validUntil: '', isActive: true, isDaily: true, maxClaims: 0 };

export default function AdminOffers() {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);
  const [saving, setSaving] = useState(false);

  const load = () => api.get('/offers/admin').then(({ data }) => setOffers(data.offers || [])).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const openAdd = () => { setEditing(null); setForm(empty); setModal(true); };
  const openEdit = (o) => {
    setEditing(o._id);
    setForm({ title: o.title, description: o.description, discount: o.discount || '', code: o.code || '', validUntil: o.validUntil ? o.validUntil.slice(0, 10) : '', isActive: o.isActive, isDaily: o.isDaily, maxClaims: o.maxClaims || 0 });
    setModal(true);
  };

  const handleSave = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      if (editing) await api.put(`/offers/${editing}`, form);
      else await api.post('/offers', form);
      setModal(false); load();
    } catch (err) { alert(err.response?.data?.message || 'Error'); }
    finally { setSaving(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this offer?')) return;
    await api.delete(`/offers/${id}`); load();
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 24 }}>OFFERS</h1>
        <button className="btn btn-primary" onClick={openAdd}>+ Create Offer</button>
      </div>
      {loading ? <div className="loading-spinner"><div className="spinner" /></div> : (
        <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid var(--border)', background: 'var(--bg-secondary)' }}>
                {['Title', 'Discount', 'Code', 'Claims', 'Valid Until', 'Status', 'Actions'].map(h => (
                  <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: 12, color: 'var(--text-secondary)', fontFamily: 'var(--font-display)', letterSpacing: '0.05em' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {offers.map(o => (
                <tr key={o._id} style={{ borderBottom: '1px solid var(--border)' }}>
                  <td style={{ padding: '12px 16px' }}>
                    <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 2 }}>{o.title}</div>
                    <div style={{ color: 'var(--text-muted)', fontSize: 12 }}>{o.description?.slice(0, 50)}...</div>
                  </td>
                  <td style={{ padding: '12px 16px' }}>{o.discount ? <span style={{ background: 'var(--gradient-gold)', padding: '3px 10px', borderRadius: 6, fontSize: 13, fontWeight: 700, color: '#fff' }}>{o.discount}</span> : '—'}</td>
                  <td style={{ padding: '12px 16px', fontFamily: 'var(--font-display)', fontSize: 13, color: 'var(--accent-cyan)' }}>{o.code || '—'}</td>
                  <td style={{ padding: '12px 16px', fontSize: 13, color: 'var(--text-secondary)' }}>{o.claimedBy?.length || 0}{o.maxClaims > 0 ? `/${o.maxClaims}` : ''}</td>
                  <td style={{ padding: '12px 16px', fontSize: 13, color: 'var(--text-secondary)' }}>{o.validUntil ? new Date(o.validUntil).toLocaleDateString() : '∞'}</td>
                  <td style={{ padding: '12px 16px' }}>
                    <span style={{ padding: '3px 10px', borderRadius: 12, fontSize: 12, fontWeight: 700, background: o.isActive ? 'rgba(16,185,129,0.15)' : 'rgba(239,68,68,0.15)', color: o.isActive ? '#10b981' : '#ef4444' }}>{o.isActive ? 'Active' : 'Off'}</span>
                  </td>
                  <td style={{ padding: '12px 16px' }}>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button className="btn btn-secondary btn-sm" onClick={() => openEdit(o)}>Edit</button>
                      <button className="btn btn-danger btn-sm" onClick={() => handleDelete(o._id)}>Delete</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {offers.length === 0 && <div style={{ padding: '40px', textAlign: 'center', color: 'var(--text-secondary)' }}>No offers yet. Create your first offer!</div>}
        </div>
      )}

      {modal && (
        <div className="modal-overlay" onClick={() => setModal(false)}>
          <div className="modal" style={{ maxWidth: 560 }} onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setModal(false)}>✕</button>
            <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 20, marginBottom: 24 }}>{editing ? 'Edit Offer' : 'Create Offer'}</h2>
            <form onSubmit={handleSave}>
              <div className="form-group"><label>Title *</label><input value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} required /></div>
              <div className="form-group"><label>Description *</label><textarea value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} rows={3} required /></div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
                <div className="form-group"><label>Discount Label</label><input placeholder="e.g. 50% OFF" value={form.discount} onChange={e => setForm({ ...form, discount: e.target.value })} /></div>
                <div className="form-group"><label>Promo Code</label><input placeholder="e.g. APEX50" value={form.code} onChange={e => setForm({ ...form, code: e.target.value })} /></div>
                <div className="form-group"><label>Valid Until</label><input type="date" value={form.validUntil} onChange={e => setForm({ ...form, validUntil: e.target.value })} /></div>
                <div className="form-group"><label>Max Claims (0 = unlimited)</label><input type="number" value={form.maxClaims} onChange={e => setForm({ ...form, maxClaims: +e.target.value })} /></div>
              </div>
              <div style={{ display: 'flex', gap: 20, marginBottom: 20 }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', color: 'var(--text-secondary)' }}>
                  <input type="checkbox" checked={form.isActive} onChange={e => setForm({ ...form, isActive: e.target.checked })} style={{ width: 'auto' }} /> Active
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', color: 'var(--text-secondary)' }}>
                  <input type="checkbox" checked={form.isDaily} onChange={e => setForm({ ...form, isDaily: e.target.checked })} style={{ width: 'auto' }} /> Daily Offer
                </label>
              </div>
              <div style={{ display: 'flex', gap: 12 }}>
                <button type="submit" className="btn btn-primary" style={{ flex: 1 }} disabled={saving}>{saving ? 'Saving...' : editing ? 'Update' : 'Create'}</button>
                <button type="button" className="btn btn-secondary" onClick={() => setModal(false)} style={{ flex: 1 }}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
